import { render } from "./CustomerDepotDiscountGroupsManagement.html?vue&type=template&id=582347bb&scoped=true"
import script from "./CustomerDepotDiscountGroupsManagement.js?vue&type=script&lang=js"
export * from "./CustomerDepotDiscountGroupsManagement.js?vue&type=script&lang=js"

import "./CustomerDepotDiscountGroupsManagement.css?vue&type=style&index=0&id=582347bb&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-582347bb"]])

export default __exports__